<footer class="footer">
  <div class="container-fluid">
    <nav class="copyright pull-left">
      Copyright &copy; 2022–2026 Crypto Explorer™. All rights reserved
    </nav>
    <div class="pull-right">
      <ul>
        <!-- <li>
                    <a class="instagram" href="https://www.instagram.com/iranhotelonline_iho"></a>
                </li>
                <li>
                    <a class="aparat" href="https://www.aparat.com/IranHotelOnline"></a>
                </li>
                  -->
      </ul>
    </div>
  </div>
</footer>
